import axios from 'axios';
import toiletReviewsData from '../../data/toilet_reviews.json';

const API_URL = process.env.REACT_APP_API_URL
const STATIC_WEBSITE = process.env.REACT_APP_STATIC_WEBSITE === 'True'

const ToiletReviewService = {
    getAllReviews: async () => {
        try {
            if (STATIC_WEBSITE) {
                return toiletReviewsData;
            } else {
                const response = await axios.get(`${API_URL}/toiletreviews/`);
                return response.data;
            }
        } catch (error) {
            console.error('Error fetching tracks:', error);
            throw error;
        }
    },

    getCount: async () => {
        try {
            if (STATIC_WEBSITE) {
                return toiletReviewsData.length;
            } else {
                const response = await axios.get(`${API_URL}/toiletreviews/count/`);
                return response.data.count;
            }
        } catch (error) {
            console.error('Error fetching review count:', error);
            throw error;
        }
    }
};

export default ToiletReviewService;